import { Box } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TopSideBar from '../../components/TopSideBar'
import PageContainer from '../../components/common/PageContainer'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { Link } from 'react-router-dom'
import OperationReports from '../../components/OperationReports'

export default function OperationReportsPage({ setBlockScreen }: any) {

  return (<>
    <TopSideBar currentSection='operations-reports' />

    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs pathlist={[
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Home
          </Link>,
          'Reportes de Operaciones']}
        />
      </Box>

      <OperationReports
        setBlockScreen={setBlockScreen}
      />
    </PageContainer>
  </>)
}